<template>
  <div>
    <el-dialog id="balanceTransfer" title="面单转移" :visible.sync="isShow"  center  class="setCustomPrintImportTemplate common-dialog" :close-on-click-modal="false" width="1100px">
      <div class="" style="padding-top: 10px;">
        <el-form :inline="true" :model="form" ref="ruleForm" label-width="90px">
          <!-- 面单来源 -->
          <el-row>
            <div class="balanceTitle">面单来源</div>
          </el-row>
          <div class="y-mt-10">
            <el-row>
              <el-form-item label="" class="customer-code">
                <div>{{transferObj.code}}-{{transferObj.name}} </div>
              </el-form-item>
              <el-form-item prop="balanceplatform" label="" class="select-label">
                <el-select v-model="form.balanceplatform.platform" placeholder="请选择平台" @change="((val)=>{platformChange(val,'balanceplatform')})" class="select-style" :disabled="isDisabled">
                  <el-option v-for="(obj, index) in form.balanceplatform.selectPlatformList" :key="index+'|'+obj.code" :label="obj.name" :value="obj.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="balanceplatform" label="" class="select-label">
                <el-select v-model="form.balanceplatform.serviceCode" placeholder="请选择服务" @change="((val)=>{codServiceChange(val,'balanceplatform')})" class="select-style" :disabled="isDisabled">
                  <el-option label="普通" value=""></el-option>
                  <el-option label="COD" value="YTOCOD" v-if="form.balanceplatform.platform=='YTO'&&form.balanceplatform.isCod=='Y'"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="balanceplatform" label="" class="select-label">
                <el-select v-model="form.balanceplatform.sellerCode" placeholder="请选择客户/商家" filterable @change="((val)=>{shopChange(val,'balanceplatform')})" class="select-style" :disabled="isDisabled">
                  <el-option v-for="(obj, index) in form.balanceplatform.sellerList" :key="index+'|'+obj.sellerId" :label="obj.sellerNick" :value="obj.sellerId">
                  </el-option>
                </el-select>
                <span class="y-ml-10" v-if="form.balanceplatform.sellerCode">余额：{{form.balanceplatform.amount}}</span>
              </el-form-item>
            </el-row>
          </div>
          <!-- 面单转出 -->
          <template v-if="isNextStep">
            <el-row>
              <div class="balanceTitle">面单转出到</div>
            </el-row>
            <div class="y-mt-10">
              <el-row>
                <el-form-item label="" class="customer-code">
                  <el-select v-model="form.balanceOutplatform.customerCode" placeholder="请选择客户编码" @change="((val)=>{changeKcode(val)})" class="select-style">
                    <el-option v-for="(obj, index) in kList" :key="index" :label="obj.customerCode + '-' + obj.customerName" :value="obj.customerCode">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="balanceOutplatform" label="" class="select-label">
                  <el-select v-model="form.balanceOutplatform.platform" placeholder="请选择平台" @change="((val)=>{platformChange(val,'balanceOutplatform')})" class="select-style">
                    <el-option v-for="(obj, index) in form.balanceOutplatform.selectPlatformList" :key="index" :label="obj.name" :value="obj.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="balanceOutplatform" label="" class="select-label">
                  <el-select v-model="form.balanceOutplatform.serviceCode" placeholder="请选择服务" @change="((val)=>{codServiceChange(val,'balanceOutplatform')})" class="select-style">
                    <el-option label="普通" value=""></el-option>
                    <el-option label="COD" value="YTOCOD" v-if="form.balanceOutplatform.platform=='YTO'&&form.balanceOutplatform.isCod=='Y'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="balanceOutplatform" label="" class="select-label">
                  <el-select v-model="form.balanceOutplatform.sellerCode" placeholder="请选择客户/商家" filterable @change="((val)=>{shopChange(val,'balanceOutplatform')})" class="select-style">
                    <el-option v-for="(obj, index) in form.balanceOutplatform.sellerList" :key="index+'|'+obj.sellerId" :label="obj.sellerNick" :value="obj.sellerId">
                    </el-option>
                  </el-select>
                  <span class="y-ml-10" v-if="form.balanceOutplatform.sellerCode">余额：{{form.balanceOutplatform.amount}}</span>
                </el-form-item>
              </el-row>
            </div>
            <!-- 转出数量 -->
            <el-row>
              <div class="balanceTitle">转出数量</div>
            </el-row>
            <div class="padingTop10">
              <el-row>
                <el-form-item label="" id="number">
                  <el-input-number type="number" v-model="form.quantity" :min="1" :max="10000" :precision="0" @blur="limitPrintNum"></el-input-number>
                </el-form-item>
                <el-form-item label="">
                  <span class="y-fc-4C84FF y-c-p" @click="transferAllQuantityFn">全部转出</span>
                </el-form-item>
              </el-row>
            </div>
          </template>
          <el-row  class="padingTop18 tocenter submitbtn">
            <el-button @click="closeDialog" class="y-fc-333 y-fw-400">取消</el-button>
            <el-button class="add-btn" v-if="!isNextStep" @click="nextFn">下一步</el-button>
            <template v-else>
              <el-button class="add-btn" @click="prevFn">上一步</el-button>
              <el-button type="primary" @click="confirmTransferFn">确定转移</el-button>
            </template>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { selectPlatformApi, getMallsAndRechargeApi, getTransferOutKcodeListApi, transferOutSubmitApi } from '../../../../../api/baseInfo/printSetting/faceBillBalanceSearch';
export default {
  props: {
    transferObj:{
      type:Object,
      default: () => {
        return {};
      }
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    isShow(val) {
      this.$emit('update:fromParentVisible', val)
    }
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      isShow: true,
      form:{
        balanceplatform: {
          customerCode: this.transferObj.code, // 客户编码
          customerName: this.transferObj.name, // 客户编码名称
          sellerCode:'',//店铺商家
          platform:'',//转移平台
          serviceCode: '',//转移服务
          sellerName:'',//转移商家
          platformName:'',//转移平台
          amount: '', // 店铺余额
          selectPlatformList:[],
          sellerList:[],
        },
        balanceOutplatform: {
          customerCode: '', // 客户编码
          customerName: '', // 客户编码名称
          sellerCode:'',//店铺商家
          platform:'',//转出平台
          serviceCode: '',//转出服务
          sellerName:'',//转出商家
          platformName:'',//转出平台
          amount: '', // 店铺余额
          selectPlatformList:[],
          sellerList:[],
        },
        quantity: 0 //转移数量
      },
      isNextStep: false,
      isDisabled: false,
      kList: []
    };
  },
  mounted() {
    this.selectPlatform('balanceplatform'); //默认查询要转出的k码支应的平台信息
  },
  methods: {
    // 查看平台
    selectPlatform(prop, kcode) {
      selectPlatformApi(
        {
          kcode: kcode ? kcode : this.transferObj.code,
          loginId:this.userMess.loginId,
          groupId:this.userMess.groupId
        }
      ).then(res=> {
        if(res.success){
          this.form[prop].selectPlatformList = res.data.platformList?res.data.platformList:[];
        }else{
          this.$message.error(res.message);
        }
      }).catch((err) => {
        this.$message.error(err.error);
      });
    },
    // 平台切换
    platformChange(val, prop) {
     this.form[prop].sellerList = [];
     this.form[prop].selectPlatformList.find(element=> {
       if(element.code === val){
         this.form[prop].platformName = element.name;
         this.form[prop].isCod = element.isCod;
       }
     })
     this.form[prop].serviceCode = '';
     this.form[prop].sellerCode = '';
     this.form[prop].sellerName = '';
     this.form[prop].amount = '';
     this.selectShopByCondition(val,prop);
    },
    // 获取店铺
    selectShopByCondition(platform,prop) {
      if(platform != 'YTO'){
        let params = {
          kcode: this.form[prop].customerCode,
          channel:platform,
          loginId:this.userMess.loginId,
          groupId:this.userMess.groupId
        }
        getMallsAndRechargeApi(params).then(res=> {
          if(res.success){
            this.form[prop].sellerList = res.data.mallBalanceList?res.data.mallBalanceList:[];
          }else{
            this.$message.error(res.message);
          }
        }).catch((err) => {
          this.$message.error(err.error);
        });
      }else{
        this.form[prop].sellerList = [];
        let list = this.tableData.filter(o => { return o.code == this.form[prop].customerCode });
        this.form[prop].sellerList = list.map(o => {
          return {
            sellerId: o.code,
            sellerNick: o.code + '-' + o.name,
            quantity: o.newWaybillCount,
            codeQuantity:o.codWaybillCount
          }
        })
        this.form[prop].sellerCode = this.form[prop].sellerList[0].sellerId;
        this.shopChange(this.form[prop].sellerList[0].sellerId,prop);
      }
    },
    codServiceChange(val, prop) {
      if (this.form[prop].sellerCode) {
        this.shopChange(this.form[prop].sellerCode,prop);
      } else {
        this.form[prop].sellerCode = '';
        this.form[prop].sellerName = '';
        this.form[prop].amount = '';
      }
    },
    shopChange(val,prop) {
      this.form[prop].sellerList.find(element=> {
        if(element.sellerId === val) {
          this.form[prop].sellerName = element.sellerNick;
          this.form[prop].amount = this.form[prop].serviceCode == 'YTOCOD' ? element.codeQuantity : element.quantity;
        }
      })
    },
    // 只能输入数字其他屏蔽
    limitPrintNum() {
      if(this.form.quantity == '' || this.form.quantity == undefined ){
        this.form.quantity = 0;
      }
    },
    // 上一步
    prevFn() {
      this.isDisabled = false;
      this.isNextStep = false;
    },
    // 下一步
    nextFn() {
      if (!this.form.balanceplatform.sellerCode) {
        this.$message.error('请选择客户/商家信息');
        return false;
      }
      if (!(this.form.balanceplatform.amount > 0)) {
        this.$message.error('面单余额为0，不可转移');
        return false;
      }
      this.isDisabled = true;
      this.isNextStep = true;
      this.getKList();
    },
    // 查询客户编码列表
    getKList() {
      getTransferOutKcodeListApi(this.transferObj.code).then(res => {
        if (res.message === 'ok') {
          this.kList = res.data || [];
          this.kList.forEach(o => {
            o.customerCode =  o.customerCode ? o.customerCode.replace(/(^\s*)|(\s*$)/g, '') : '';
          })
        } else {
          this.kList = [];
          this.$message.error(res.error);
        }
      }).catch(err => {
        this.kList = [];
        this.$message.error(err.error);
      })
    },
    // 切换k码
    changeKcode(kcode) {
      let kCodeList = this.kList.filter(o => { return o.customerCode == this.form.balanceOutplatform.customerCode});
      this.form.balanceOutplatform.customerName = kCodeList[0].customerName;
      this.form.balanceOutplatform.platform = '';
      this.form.balanceOutplatform.sellerCode = '';
      this.form.balanceOutplatform.sellerName = '';
      this.form.balanceOutplatform.amount = '';
      this.selectPlatform('balanceOutplatform', kcode);
    },
    // 关闭dialog
    closeDialog() {
      this.isShow = false;
      this.$emit('update:fromParentVisible',false);
    },
    // 全部转出
    transferAllQuantityFn() {
      if (!this.form.balanceOutplatform.sellerCode) {
        this.$message.error('请选择转出客户/商家信息');
        return false;
      }
      this.form.quantity = this.form.balanceplatform.amount;
    },
    // 确认转移
    confirmTransferFn() {
      if (!this.form.quantity) {
        this.$message.error('请输入转出数量');
        return false;
      }
      if (this.form.balanceplatform.platform == this.form.balanceOutplatform.platform && 
          this.form.balanceplatform.serviceCode == this.form.balanceOutplatform.serviceCode &&
          this.form.balanceplatform.sellerCode == this.form.balanceOutplatform.sellerCode) {
        this.$message.error('请勿重复选择');
        return false;
      }
      if (!this.form.balanceOutplatform.sellerCode) {
        this.$message.error('请选择转出客户/商家信息');
        return false;
      }
      this.$confirm('请确认是否转移面单，面单转移后不可撤回?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.sumbitApi();
      }).catch(() => {});
    },
    sumbitApi() {
      let params = {
        // 面单来源信息
        fromCustomerCode: this.form.balanceplatform.customerCode,
        fromCustomerName: this.form.balanceplatform.customerName,
        fromTerraceCode: this.form.balanceplatform.platform,
        fromTerraceName: this.form.balanceplatform.platformName,
        fromServiceCode: this.form.balanceplatform.serviceCode == 'YTOCOD' ? 'YTOCOD' : 'COMMON',
        fromServiceName: this.form.balanceplatform.serviceCode == 'YTOCOD' ? '圆通COD' : '普通',
        fromSellerCode: this.form.balanceplatform.sellerCode,
        fromSellerName: this.form.balanceplatform.sellerName,
        // 面单转出信息
        allotToCode: this.form.balanceOutplatform.customerCode,
        allotToName: this.form.balanceOutplatform.customerName,
        terraceCode: this.form.balanceOutplatform.platform,
        terraceName: this.form.balanceOutplatform.platformName,
        serviceCode: this.form.balanceOutplatform.serviceCode == 'YTOCOD' ? 'YTOCOD' : 'COMMON',
        serviceName: this.form.balanceOutplatform.serviceCode == 'YTOCOD' ? '圆通COD' : '普通',
        sellerCode: this.form.balanceOutplatform.sellerCode,
        sellerName: this.form.balanceOutplatform.sellerName,
        transferQty: this.form.quantity,
        operateSource: 1 // 1 客户管家 2 app
      }
      transferOutSubmitApi(params).then(res => {
        if (res.message === 'ok') {
          this.$message.success('面单正在转移，预计需要5分钟');
          this.closeDialog();
        } else {
          this.$message.error(res.error || res.message || '提交失败，请稍候重试');
        }
      }).catch(err => {
        this.$message.error(err.error|| err.message || '网络错误，请稍候重试');
      })
    }
  }
};
</script>
<style lang="scss">
@import "../../../../../styles/variables";
#balanceTransfer {
  .balanceTitle::before{
    position: absolute;
    content: " ";
    height: 10px;
    left: 0px;
    border: 2px solid $blue-style;
  }
  .balanceTitle {
    margin-left: 10px;
  }
  .el-table {
    .el-table__body-wrapper {
      max-height: 559px !important;
    }
    .cell {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
  .add-btn{
    background: $blue-style;
    border-radius: 3px;
    color: #ffffff;
    border: 1px solid $blue-style;
  }
  .padingTop18{
    padding-top: 18px;
    .el-form-item__label{
      color: #666666;
      font-weight: 400;
      line-height: 34px;
    }
    .el-form-item__content{
      color: #333333;
      font-weight: 400;
      line-height: 34px;
    }
  }
  .tocenter{
    text-align: center;
    padding-bottom: 20px;
  }
  .padingTop10{
    padding-top: 15px;
    .el-form-item__label{
      color: #666666;
      font-weight: 400;
      line-height: 34px;
    }
    .el-form-item__content{
      color: #333333;
      font-weight: 400;
      line-height: 34px;
    }
  }
  .select-style{
    width: 200px;
    height: 34px;
    border-radius: 4px;
  }
  .customer-code .el-form-item__label{
    color: #333333;
    font-weight: 600;
  }
  .customer-code .el-form-item__content{
    color: #333333;
    font-weight: 600;
  }
}
#balanceTransfer .el-input,
#balanceTransfer .el-input .el-input__inner {
  width: 200px;
}
.select-style .el-input,
.select-style .el-input .el-input__inner {
  height: 34px !important;
}
#number .el-input,
#number .el-input .el-input__inner {
  width: 130px;
  height: 34px;
}
#number .el-form-item__content,
#number .el-input-number--small {
  width: 130px;
}

#number{
  line-height: 32px;
  .el-input-number__decrease,.el-input-number__increase{
    height: 32px;
    line-height: 32px;
  }
  .select-label{
    line-height: 32px;
  }
}
.submitbtn .el-button{
  height: 40px;
  width: 100px;
  border-radius: 3px;
  // font-size: 20px;
}
</style>
